import api from 'Application/api/api';

const archiveEmployee = (id, cancelToken = null) =>
    api.post(`/employees/${id}/archive`, {}, { cancelToken });

export default archiveEmployee;
